import { DashboardLoginPage } from "@dashboard/components/login/LoginPage"
import { dashboardAppHostRedirectUrl } from "@playbrain/config/dashboard-host"
import { currentRequestHostname } from "@playbrain/config/dashboard-host-runtime"
import { createFileRoute, redirect } from "@tanstack/react-router"

type LoginSearch = {
  returnTo?: string
  error?: string
}

export const Route = createFileRoute("/login")({
  validateSearch: (search): LoginSearch => ({
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
    error: typeof search.error === "string" ? search.error : undefined,
  }),
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
  component: LoginRoute,
})

function LoginRoute() {
  const search = Route.useSearch()
  return (
    <DashboardLoginPage
      returnTo={search.returnTo}
      routeError={search.error}
    />
  )
}
